import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-headers-styles',
  templateUrl: './headers-styles.component.html',
  styleUrls: ['./headers-styles.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HeadersStylesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/headers-styles/headers-styles.component.ts